<template>
  <div>
    <div class="box"  v-show="currentStep == 0" style="margin-top: 20px;">
      <div class="box-header">
        <h3>출입자 별 퇴실 정보 입력</h3>
        <small>반출자산 확인, 카드반납여부확인, 퇴실처리 직원확인</small>
      </div>
      <div class="box-body">
        <form action="">
          <div class="form-group row">
            <label class="col-2 form-control-label">
              <span class="ess">퇴실 처리직원</span>
            </label>
            <div class="col-10 pt-2">
              <input type="text" v-model="commonData.checkOutEmployeeName"  class="form-control form-control-success" v-on:keydown.enter.prevent="save()">
              <input type="text" v-model="commonData.uuid"  class="form-control form-control-success" v-if="false">
            </div>
          </div>
        </form>
      </div>
      <div class="scroll-tbl pl-20 pr-20" >
        <div class="thead">
          <table class="tbl no-outline">
            <colgroup>
              <col width="40px">
              <col width="60px">
              <col width="100px">
              <col width="100px">
              <col width="100px">
              <col width="auto">
              <col width="auto">
            </colgroup>
            <thead>
              <tr>
                <th></th>
                <th>이름</th>
                <th>칸번호</th>
                <th>카드번호</th>
                <th>출입카드 반납</th>
                <th>반출자산 확인</th>
                <th>비고</th>
              </tr>
            </thead>
          </table>
        </div>
        <!--div class="tbody" style="height:450px" ui-jp="mCustomScrollbar" ui-options="{theme:'dark-thick'}"-->
        <div class="tbody scroll-wrap" style="height:315px; overflow: auto;">
          <table class="tbl no-outline">
            <colgroup>
              <col width="40px">
              <col width="60px">
              <col width="100px">
              <col width="100px">
              <col width="100px">
              <col width="auto">
              <col width="auto">
            </colgroup>
            <tbody>
              <tr v-for="(item, index) in data" :key="index">
                <td></td>
                <td>{{item.visitor.visitorName}}</td>
                <td>{{item.spaceNumber}}</td>
                <td>{{item.cardNumber}}</td>
                <td>
                  <div class="input-group align-top">
                    <dropdown v-model="item.isReturnCard" :datasource="cardStatus" :width="70"/>
                  </div>
                </td>
                <td>
                  <AssetList :value="item.assetCheckList" :height="100" :editMode="true" @change="assetCheckChange"/>
                </td>
                <td><textarea class="form-control w430" placeholder="메세지를 적어주세요." style="height:100px" v-model="item.memo"></textarea></td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>



    <div class="btn-wrap justify-content-center mt-30 mb-40">
      <button class="btn btn-lg blue"  @click="save()" :disabled="checkSave">완료
        <i class="icon-check ml-5" ></i>
      </button>
    </div>
  </div>
</template>

<script>
import LocationTable from './LocationTable.vue';
import AssetList from './AssetList.vue';
import LocationList from './LocationList.vue';
import Dropdown from "@/components/Dropdown.vue"
import LocationBase from '@/components/common/locationBase'

export default {
  mixins: [LocationBase],
  components: { LocationTable,AssetList, LocationList, Dropdown},
  props: {
    title: String,
    data : {
      default: [],
    },
  },
  data(){
    return {
      assets: [{name: 'note'}],
      currentStep: 0,
      commonData: {uuid:''},
      locationDataList: [],
      saveLocationList: [],
      fromListData: [],
      toListData:[],
      cardStatus: [{name:'반납', value: 1}, {name: '미반납', value: 0}],
    }
  },
  computed: {
    checkSave(){
      var that = this;
      var result = false;
      if(!this.commonData.uuid){
        return true;
      }
      if(!this.commonData.checkOutEmployeeName){
        return true;
      }
      this.data.forEach(x=>{
        if(x.assetCheckList){
          if(x.assetCheckList.filter(z=>z.checked).length != x.assetCheckList.length){
            result = true;
            return;
          }
        }
      })
      return result;
    },
    isSelected(){
      item.visitor.assetList.filter(x => x.checked)
    },
    checkedAssets() {
      return (item) =>{
        return item.visitor.assetList.filter(x => x.checked)
      }
    },

    getAssetName(){
      return (asset) =>{
        return asset.assetStr + '('+ asset.assetSerial + ')';
      }
    },
    getCurrentStep(){
      return (step) =>{
        var result = ''
        if(step < this.currentStep)
          result = 'checked';
        if(this.currentStep == step)
          result = 'on'
        return result;
      }
    }
  },
  mounted(){
    this.init();
    this.currentStep = 0;
    setTimeout(()=>{
      $('.scroll-wrap').mCustomScrollbar({
        theme: 'dark-thick',
      });

    },500)

  },
  methods: {
    init(){
      this.commonData.uuid = this.uuidv4();

      //디폴트가 카드 반납이 되어있도록
      this.data.forEach(item => item.isReturnCard = 1);
      this.initAssetList();

    },
    initAssetList(){
      var that = this;
      this.data.forEach(x=>{

        var assetList = JSON.parse(x.assetList) || [];
        var assetCheckList = x.visitor.assetList.filter(y => {
          return assetList.indexOf(''+y.visitorAssetIndex) > -1 || assetList.indexOf(y.visitorAssetIndex) > -1
        });

        x.assetCheckList = null;
        assetCheckList.forEach(z=>{
          z.checked = false;
        })

        x.assetCheckList = assetCheckList;
      })
      this.$forceUpdate();
    },
    assetCheckChange(items){

      this.commonData.uuid = this.uuidv4();
      items.forEach((x)=>{x.checked = !x.checked;x.checked = !x.checked})
      //this.$forceUpdate();
    },

    save(){

      if(this.checkSave) {
        this.noti('퇴실 정보 확인', '퇴실 처리직원 정보 또는 반출 자산을 확인해 주세요.', 'warning');
        return ;
      }

      var that = this;
      var list = this.copyNew(this.data);
      var saveList = [];
      list.forEach(o => {
        var obj = {};
        obj.checkOutEmployeeName = that.commonData.checkOutEmployeeName;
        obj.checkInIndex = o.checkInIndex;

        obj.isReturnCard = o.isReturnCard
        obj.memo = o.memo

        obj.uuid = o.visitor.uuid;
        saveList.push(obj);
      });

      this.$http.post('/api/private/visitor/checkOut', saveList)
        .then((result) => {
          // this.$toast.success('체크아웃 되었습니다.');
          this.noti('완료', '체크아웃 완료되었습니다.', 'success');
          this.closeModal();
          this.$attrs.opener.findAll();
        }).catch((e) =>{
          console.log(e);
      })
    },
    nextStep(){
      if(this.currentStep == 0){

        this.currentStep +=1;

        this.locationDataList = this.getParseLocation(this.data[0].visitor.visitLocation);
      }
    },
    getAssetType(code) {
      return_.find(this.$store.getters['dataprovider/asset'],{'assetCode': code})
    },
    prevStep(){
      if(this.currentStep > 0)
        this.currentStep -=1;
    },

  }
}
</script>

<style>

</style>
